// TODO: migrate this hammer configuration stuff to typescript when installing hammerjs npm package
// It wasn't done previously for these reasons:
//    This logic can't easily be converted to options or overrides in CustomHammerConfig.ts,
//    since this logic is changing defaults on the prototypes, which is not what the HammerGestureConfig is for.
//    Also, the configuration options that come from HammerGestureConfig (the parent of CustomHammerConfig) only apply for Hammer instances created
//    through the HammerGesturesPlugin, so it wouldn't affect the manual creation of instances that we are currently doing
//    in our angularjs code, and via the angular-hammer package.
//    This would be a problem because currently, we want this configuration below to apply in angularjs and Angular.
//    (It is fine right now because it is applying to both angularjs and Angular, since they are both referencing the same 'Hammer' object off of the window)
angular.module('aprima-core-ui').config(function() {
    'use strict';

    //This makes the recognizer work better on samsung galaxy devices.
    //Before this change, tap events would only fire ~10% of the time.
    //https://github.com/hammerjs/hammer.js/issues/804
    //https://github.com/hammerjs/hammer.js/issues/683
    window.Hammer.Tap.prototype.defaults.threshold = 9;
    window.Hammer.Tap.prototype.defaults.time = 499;

    // make hammer respect disabled attribute
    // by re-defining the handler prototype on each type of Input
    var inputHandlerKey = 'handler';
    var wrappedKey = '_';
    _(window.Hammer)
        .pickBy('prototype.' + inputHandlerKey)
        .forOwn(function(inputType) {
            var inputHandler = inputType.prototype[wrappedKey + inputHandlerKey] = inputType.prototype[inputHandlerKey];
            inputType.prototype[inputHandlerKey] = function() {
                if(this && this.element && this.element.disabled) {
                    return;
                }
                return inputHandler.apply(this, arguments);
            };
        });
});